import { BigNumber, ethers } from 'ethers'

export function getSettlementMode(address) {
    return !address || address === ethers.constants.AddressZero ? 'native' : 'erc20'
}

export function isSettlementTokenReady({ mode, address, token }) {
    if (mode === 'native') return true
    if (!ethers.utils.isAddress(address) || !token?.address) return false
    return token.address.toLowerCase() === address.toLowerCase()
}

export function buildVisibleFeeRows({
    projectFeeAmount,
    platformFeeAmount,
    royaltyAmount,
    sellerProceeds,
}) {
    const feeRows = [
        ['projectFee', projectFeeAmount],
        ['platformFee', platformFeeAmount],
        ['royalty', royaltyAmount],
    ]
        .filter(([, amount]) => amount && !BigNumber.from(amount).isZero())
        .map(([key, amount]) => ({ key, amount }))

    return [...feeRows, { key: 'sellerGets', amount: sellerProceeds, total: true }]
}
